import React from "react";
import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import type { TextFieldProps } from "@mui/material/TextField";

const QuantityTextField: React.FC<TextFieldProps> = styled(
  (props: TextFieldProps) => <TextField {...props} />
)(({ theme }) => ({
  "& .MuiInputBase-root": {
    width: "90%",
  },
  "& .MuiFormHelperText-root": {
    margin: 4,
    marginRight: 0,
    fontSize: 10,
  },
}));

export default QuantityTextField;
